// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminTokens_wrapper__lmB4S","container":"AdminTokens_container__Ucoa1"};